import React from "react";
import "bootstrap-icons/font/bootstrap-icons.css";

const features = [
  { icon: "bi-bag-check-fill", text: "Secure Shopping" },
  { icon: "bi-droplet-fill", text: "Hypoallergenic Materials" },
  { icon: "bi-wallet-fill", text: "Cash on Delivery" },
  { icon: "bi-gift-fill", text: "Gift Wrapping Available" },
  { icon: "bi-calendar2-check-fill", text: "Easy Return" },
];

const Usp = () => {
  return (
    <div className="usp-marquee py-3">
      <div className="marquee-track">
        {[...features, ...features].map((item, index) => (
          <div key={index} className="usp-item">
            <div className="icon">
              <i className={`bi ${item.icon}`}></i>
            </div>
            <span>{item.text}</span>
          </div>
        ))}
      </div>

      {/* Styles */}
      <style>
        {`
        .usp-marquee {
          overflow: hidden;
          background: #f8f8f8;
        }

        .marquee-track {
          display: flex;
          width: max-content;
          animation: scroll 30s linear infinite;
        }

        .usp-item {
          display: flex;
          align-items: center;
          gap: 8px;
          padding: 0 30px;
          white-space: nowrap;
          font-size: 14px;
          color: #424141;
        }

        .usp-item .icon {
          font-size: 16px;
        }

        /* Divider */
        .usp-item::after {
          content: "|";
          margin-left: 20px;
          color: #ccc;
        }

        /* Animation */
        @keyframes scroll {
          0% {
            transform: translateX(0);
          }
          100% {
            transform: translateX(-50%);
          }
        }

        /* Pause on hover */
        .usp-marquee:hover .marquee-track {
          animation-play-state: paused;
        }
        `}
      </style>
    </div>
  );
};

export default Usp;